import React, { useEffect, useState, useRef } from 'react';


import { Helmet } from 'react-helmet';
import './home.css';
import { setupScrollAnimations } from '../utils/scrollAnimation';
import ImageCarousel from '../components/ImageCarousel';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Lightbox from '../components/Lightbox';
import { Link } from 'react-router-dom';
import HeroSlider from '../components/HeroSlider';

const Home = () => {
  useEffect(() => {
    setupScrollAnimations();
    AOS.init({ duration: 1000, once: true });
  }, []);


  // constante pour carroussel gallerie
  const [selectedImage, setSelectedImage] = useState(null);

  const sliderRef = useRef(null);
  const autoRef = useRef(null);

  const scrollByOne = (dir) => {
    const viewport = sliderRef.current;
    if (!viewport) return;

    const firstSlide = viewport.querySelector('.slide');
    if (!firstSlide) return;

    const styles = window.getComputedStyle(viewport.querySelector('.slider-track'));
    const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;

    const slideW = firstSlide.getBoundingClientRect().width;
    const step = slideW + gap;

    viewport.scrollBy({ left: dir * step, behavior: 'smooth' });

    // Re-check après l'animation smooth (évite le blocage sur les clones)
    window.setTimeout(() => {
      handleInfiniteScroll();
    }, 550);

  };


  const handleInfiniteScroll = () => {
    const viewport = sliderRef.current;
    if (!viewport) return;

    const track = viewport.querySelector('.slider-track');
    if (!track) return;

    const firstSlide = track.querySelector('.slide');
    if (!firstSlide) return;

    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.gap || 0) || 0;
    const slideW = firstSlide.getBoundingClientRect().width;

    // On a ajouté 3 clones à la fin
    const clonesCount = 3;

    // Position à partir de laquelle on est dans les clones
    // (après les "vraies" images)
    const cloneStart = (slideW + gap) * images.length;

    // Petite marge pour éviter les problèmes de snap/arrondi
    const epsilon = 2;

    // Si on est arrivé dans la zone des clones -> retour au début réel
    if (viewport.scrollLeft >= cloneStart - epsilon) {
      viewport.scrollTo({ left: 0, behavior: 'auto' });
    }

    // Bonus : si jamais on scroll "trop" loin (sécurité)
    const maxScroll = track.scrollWidth - viewport.clientWidth;
    if (viewport.scrollLeft >= maxScroll - epsilon) {
      viewport.scrollTo({ left: 0, behavior: 'auto' });
    }
  };


  const startAuto = () => {
    stopAuto();
    autoRef.current = setInterval(() => scrollByOne(1), 4500);
  };

  const stopAuto = () => {
    if (autoRef.current) clearInterval(autoRef.current);
    autoRef.current = null;
  };

  useEffect(() => {
    startAuto();
    return () => stopAuto();
  }, []);

  const images = Array.from({ length: 10 }, (_, i) =>
  `/img/galerie/lehameau/img${i + 1}.jpg`);



  return (
    <div className="home-page">
      <Helmet>
        <title>Le Hameau du Sorbier</title>
        <meta name="description" content="Location de vacances de charme en pleine nature." />
      </Helmet>

      <HeroSlider images={["/img/fond1.jpg", "/img/fond2.jpg"]} interval={15000} zoom={1.1} />

      

      <section className="section section-text-img" data-aos="fade-up">
        <div className="text">
          <h2>Le cadre de vie</h2>
          <p>
           Au cœur du Périgord Noir, cette magnifique maison en pierre, emblématique de la région, nichée au calme de la campagne et à proximité immédiate des plus beaux sites touristiques. Au sein du hameau privé du Sorbier sans voisinage (hormis les propriétaires), ni circulation, la maison vous garantit un calme absolu et une tranquillité totale.

            Elle s’ouvre sur une propriété de 60 hectares de bois et de prairies qui vous offre un environnement naturel préservé, entre sentiers de randonnés, chant des oiseaux et ciel étoilé. Un lieu idéal pour se ressourcer et profiter pleinement de la nature.

          </p>
        </div>
        <div className="image" style={{ backgroundImage: 'url(/img/galerie/lehameau/sansardoise.png)' }} />
      </section>


      <section
        id="lieu"
        className="section section-text-img reverse"
        data-aos="fade-up"
      >
        <div className="text">
          <h2>Activités au sein du hameau</h2>
          <p>
            Pensé comme un lieu de vie et de partage, le Hameau du Sorbier invite à
            ralentir le rythme et à profiter pleinement de chaque instant.
            Entre moments de détente au bord de la piscine, parties conviviales en
            plein air et instants de calme sous les étoiles, chacun trouve ici
            l’équilibre qui lui ressemble.
          </p>

          <p>
            Que vous soyez en quête de repos, de nature ou de loisirs simples à
            partager en famille ou entre amis, le hameau offre un cadre privilégié,
            préservé de toute pollution lumineuse, propice à la déconnexion.
          </p>

          <a href="/activites-hameau" className="text-link">
            Découvrir l’ensemble des activités →
          </a>
        </div>

        <div
          className="image"
          style={{ backgroundImage: 'url(/img/galerie/lehameau/img14.jpg)' }}
        />
      </section>


      <section className="section section-features bg-cream round-top round-bottom" data-aos="fade-up">
        <h2>Un lieu chargé d’histoire</h2>

        <p className="features-text">
          Ancien domaine familial reconverti en havre de paix, le Hameau du Sorbier
          vous offre une immersion dans un environnement authentique, chaleureux
          et inspirant.
        </p>

        <div className="features-images">
          <img src="/img/autres/ancienMaison.png" alt="La Maison" />
          <img src="/img/autres/ancienPigeonier.png" alt="Le Pigeonier" />
          <img src="/img/autres/ancienEtable.png" alt="L'Étable" />
        </div>
      </section>




    

      {/* <section id="lodging" className="section gallery bg-cream round-top round-bottom">
        <h2>Nos hébergements</h2>
        <div className="gallery-grid" data-aos="fade-up">
          {[
            { img: "/galerie/lamaison-exterieur/img11.jpg", nom: "La Maison", lien: "/maison" },
            { img: "comingSoon.png", nom: "La Grange", lien: "/grange" },
            { img: "comingSoon.png", nom: "L'Etable", lien: "/etable" },
          ].map((heb, i) => (
            <div key={i} className="hebergement-card">
              <Link to={heb.lien}>
                <div
                  className="hebergement-img"
                  style={{ backgroundImage: `url(/img/${heb.img})` }}
                />
              </Link>
              <h3>
                <Link to={heb.lien}>{heb.nom}</Link>
              </h3>
            </div>
          ))}
        </div>
      </section> */}



      <section className="section gallery-preview" data-aos="fade-up">
        <div className="gallery-header">
          <Link to="/galerie">
            <h2 className="gallery-title">Galerie</h2>
          </Link>
          {/* <ImageCarousel images={["/img/chambre1.jpg", "/img/fond1.jpg", "/img/pigeonnier_dos_1.jpg"]} /> */}
        </div>
       

        <div className="gallery-slider" aria-label="Aperçu de la galerie">
          <button  className="slider-nav slider-prev" type="button"   aria-label="Image précédente"  onClick={() => scrollByOne(-1)}          >
            ‹
          </button>

          <div
            className="slider-viewport"
            ref={sliderRef}
            onScroll={handleInfiniteScroll}
            onMouseEnter={stopAuto}
            onMouseLeave={startAuto}
          >
            <div className="slider-track">
              {/* 10 images normales */}
              {images.map((src, i) => (
                <Link to="/galerie" key={`real-${i}`} className="slide">
                  <div className="slide-img" style={{ backgroundImage: `url(${src})` }} />
                </Link>
              ))}

              {/* 3 clones pour faire la boucle */}
              {images.slice(0, 3).map((src, i) => (
                <Link to="/galerie" key={`clone-${i}`} className="slide">
                  <div className="slide-img" style={{ backgroundImage: `url(${src})` }} />
                </Link>
              ))}
            </div>
          </div>

          <button
            className="slider-nav slider-next" type="button" aria-label="Image suivante" onClick={() => scrollByOne(1)}>
            ›
          </button>
        </div>




      </section>

      <section
        id="booking"
        className="section booking bg-image-cover"
        style={{ backgroundImage: "url('/img/fond1.jpg')" }}
        data-aos="fade-up"
      >
        <div className="bg-image-inner booking-inner">
          <h2>Prêt à réserver ?</h2>
          <p></p>
          <Link to="/maison" className="btn-book">
            Réserver maintenant
          </Link>

          <p> Contactez-nous par mail à : contactccl@free.fr ou par téléphone au 06 89 67 34 75 </p>
        </div>
      </section>


      {/* <section id="contact" className="section contact-section" data-aos="fade-up">
        <h2> <center>Nous contacter</center> </h2>
        <form className="contact-form">
          <input type="email" placeholder="Votre e-mail" required />
          <input type="text" placeholder="Votre nom" required />
          <input type="text" placeholder="Votre prénom" required />
          <input type="text" placeholder="Votre numéro de téléphone" required />
          <textarea placeholder="Votre message" rows="5" required />
          <button type="submit">Envoyer</button>
        </form>
      </section>
      */}

      <section id="location" className="section location-section round-top round-bottom" data-aos="fade-up">
        <h2><center>Où nous trouver ?</center></h2>
        <p>
          <center>Le Hameau du Sorbier se situe au 70 Impasse du Sorbier, 24120 La Cassagne, en Dordogne, Nouvelle-Aquitaine, France. </center>
        </p>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d570.5492475980593!2d1.3155705622040217!3d45.05602415584128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f8a93987e8f3b1%3A0x353b7dde58447422!2s70%20Imp.%20du%20Sorbier%2C%2024120%20La%20Cassagne!5e1!3m2!1sfr!2sfr!4v1748178562588!5m2!1sfr!2sfr"
            width="600"
            height="450"
            style={{ border: 1 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>

      <section
        className="section reviews-section bg-image-cover round-top round-bottom"
        style={{ backgroundImage: "url('/img/autres/mur2.jpeg')" }}
        data-aos="fade-up"
      >
        <div className="bg-image-inner">
          <div className="reviews-header">
            <div className="reviews-title">
              <h2>Ils en parlent mieux que nous</h2>
              <img
                src="/img/autres/discussion.webp"
                alt="Discussion"
                className="reviews-icon"
              />
            </div>
          </div>
        </div>

        <div className="reviews-grid">
          {/* AVIS 1 - Airbnb */}
          <a
            className="review-card"
            href="https://www.airbnb.fr/rooms/23318454/reviews?source_impression_id=p3_1766251099_P3_hippUFSZaxD8x&scroll_to_review=1489772800495476623"  // <- remplace par le lien exact
            target="_blank"
            rel="noreferrer"
            aria-label="Voir l’avis sur Airbnb"
          >
            <div className="review-top">
              <div className="review-source">
                <img className="review-logo" src="/img/autres/airbnb.png" alt="Airbnb" />
                <span className="review-source-text">Airbnb</span>
              </div>
              <div className="review-rating" aria-label="Note 5 sur 5">
                ★★★★★
              </div>
            </div>

            <p className="review-text">
              “Une semaine si brillante à La Cassagne - famille de 5 avec des enfants âgés de 6 à 12 ans et passé toute la journée dans la piscine dans un cadre magnifique. Nous n'étions pas allés en Dordogne auparavant et la région est magnifique. Nous avons fait du canoë sur la rivière, visité de beaux villages et villes, de grands marchés et avons également eu de délicieux barbecues à la maison. Laurent était très sympathique et incroyablement serviable et réactif à toutes les questions. La maison a été récemment rénovée et très joliment aménagée avec une belle piscine. Environnement très paisible et bons sentiers de marche et de course à pied depuis la porte d'entrée. 
Je le recommande vivement si vous cherchez une semaine pour vous ressourcer dans une belle partie du monde !”
            </p>

            <div className="review-footer">
              <span className="review-author">Jenny</span>
              <span className="review-date">Août 2025</span>
            </div>
          </a>

          {/* AVIS 2 - Abritel */}
          <a
            className="review-card"
            href="https://www.airbnb.fr/rooms/23318454/reviews?source_impression_id=p3_1766251099_P3_hippUFSZaxD8x&scroll_to_review=1489772800495476623" // <- remplace
            target="_blank"
            rel="noreferrer"
            aria-label="Voir l’avis sur Airbnb"
          >
            <div className="review-top">
              <div className="review-source">
                <img className="review-logo" src="/img/autres/airbnb.png" alt="Airbnb" />
                <span className="review-source-text">Abritel</span>
              </div>
              <div className="review-rating" aria-label="Note 5 sur 5">
                ★★★★★
              </div>
            </div>

            <p className="review-text">
              “Laurent et son épouse sont des hôtes parfaits. Ils sont accueillants, prévenants et discrets. 
Nous avons passé un excellent séjour dans une jolie maison de charme rénovée avec goût et extrêmement bien équipée. 
L’environnement est beau, paisible ressourçant et les alentours offrent une multitude d’activités sportives et culturelles. 
En bref, une magnifique semaine que nous renouvellerons probablement.”
            </p>

            <div className="review-footer">
              <span className="review-author">Gaelle</span>
              <span className="review-date">Août 2025</span>
            </div>
          </a>
          

          
        </div>
      </section>


      <footer className="main-footer">
        <div className="footer-content">
          <p>&copy; {new Date().getFullYear()} Le Hameau du Sorbier</p>

          <div className="footer-links">

              <a
              href="https://www.airbnb.fr/rooms/23318454?source_impression_id=p3_1766251099_P3_hippUFSZaxD8x&scroll_to_review=1489772800495476623"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Airbnb"
            >
              <img src="/img/autres/airbnb.png" alt="Airbnb" />
            </a>


            <a
              href="https://www.abritel.fr/location-vacances/p2559738"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Abritel"
            >
              <img src="/img/autres/abritel.png" alt="Abritel" />
            </a>


            <a
              href="https://www.booking.com/hotel/fr/maison-de-charme-avec-piscine-en-perigord.html?aid=374992&lang=fr&label=hotel&chal_t=1767182830196&force_referer=https%3A%2F%2Fwww.google.com%2F"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Booking"
            >
              <img src="/img/autres/booking.png" alt="Booking" />
            </a>

            
          </div>
        </div>
      </footer>


      <Lightbox image={selectedImage} onClose={() => setSelectedImage(null)} />
    </div>
  );
};

export default Home;